module.exports = __webpack_public_path__ + "img/zurich.4ce0f03.svg";